<template>
  <div
    class="pb-4"
    :class="{
      'emd-panel eu-no-padding': !label,
      'emd-panel__section': label
    }"
  >
    <div
      class="emd-panel__block"
      v-if="label"
    >
      <div class="el-chunk">
        <h2 class="emd-text _color_default _type_caption">{{ $t(label) }}</h2>
      </div>
    </div>
    <div v-bind:class="{ 'emd-panel__block': label }">
      <JadeInputField
        size="medium"
        :type="inputType"
        :label="$t('users.edit.password')"
        :placeholder="$attrs.placeholder"
        :value="value"
        :error="hasError"
        :supportText="hasError ? $t('general.password-error') : ''"
        :trailingItem="trailingItem"
        autocomplete="current-password"
        @onTrailingItemClick="handleTrailingItemClick"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
import { JadeInputField } from '@jade'

export default {
  name: 'PasswordConfirmation',
  components: {
    JadeInputField
  },
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: 'payment-methods.config.password-label'
    },
    hasError: Boolean
  },

  data () {
    return {
      inputType: 'password',
      trailingItem: { content: 'eye-close', type: 'icon' }
    }
  },

  methods: {
    onInput (value) {
      this.$emit('input', value)
    },
    handleTrailingItemClick () {
      this.trailingItem.content =
        this.inputType === 'password' ? 'eye-open' : 'eye-close'
      this.inputType =
        this.trailingItem.content === 'eye-open' ? 'text' : 'password'
    }
  }
}
</script>
